import React, { useEffect, useState } from 'react';
import { Tag, Copy, Check } from 'lucide-react';
import { promosAPI } from '../services/api';
import { useT } from '../services/i18n';

export const usePromoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { promosAPI.banner().then(b => setBanner(b?.active ? b : null)).catch(() => {}); }, []);
  const copy = async () => {
    try { await navigator.clipboard.writeText(banner.code.trim()); } catch (_) { /* clipboard blocked */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return banner ? { banner, copied, copy } : null;
};

export const PromoCode = ({ banner, copied, copy, t }) => banner.code ? (
  <button type="button" onClick={copy} data-testid="promo-banner-code" title={t('promo.copyCode')} className="inline-flex items-center gap-1 font-mono font-bold bg-white text-orange-600 rounded px-2 py-0.5 hover:bg-orange-50 transition-colors">
    {banner.code} {copied ? <Check size={12} /> : <Copy size={12} />}
  </button>
) : null;

const PromoBanner = ({ className = '' }) => {
  const { t, lang } = useT();
  const p = usePromoBanner();
  if (!p) return null;
  return (
    <div className={`bg-orange-500 text-white text-sm ${className}`} data-testid="promo-banner">
      <div className="container mx-auto px-4 py-1.5 flex flex-wrap items-center justify-center gap-2 text-center">
        <Tag size={14} className="flex-shrink-0" />
        <span data-testid="promo-banner-text">{p.banner.text_i18n?.[lang] || p.banner.text}</span>
        <PromoCode {...p} t={t} />
        {p.copied && <span className="text-xs text-orange-100" data-testid="promo-banner-copied">{t('promo.copied')}</span>}
      </div>
    </div>
  );
};

export default PromoBanner;
